import axios from 'axios';
import ReduxStore from '../ReduxStore';
import {clearError, error} from 'ducks/finalise';
import {resetReportUrl} from 'ducks/reportUrl';
import {getIn} from 'lib/immutableObject';
import {trackReport} from 'api/reports/tracking/TrackableReportUtil';
import {getSOIReportPayload} from 'api/reports/soi/SOIReportFactory';
import {getCMAReportPayload} from 'api/reports/cma/CMAReportFactory';
import {TIMEOUTS} from 'lib/Commons';

const reportUrls = {
  cma: '/api/reports/cma',
  rental: '/api/reports/cma',
  soi: '/api/reports/soi',
};


const PROPERTY_PRICE_STATEMENT_URL = '/api/reports/pps';

export function getReportUrl(reportType) {
  if (reportType === 'soi' && ReduxStore.getState().featureFlags.propertyPriceStatement) {
    return PROPERTY_PRICE_STATEMENT_URL;
  }
  return reportUrls[reportType];
}

export const payloads = {
  cma: getCMAReportPayload('cma'),
  rental: getCMAReportPayload('rental'),
  soi: getSOIReportPayload,
};

const ReportApi = {
  getPayload(reportType) {
    return payloads[reportType]();
  },
  async fetchReport(reportType) {
    ReduxStore.dispatch(resetReportUrl(null));
    ReduxStore.dispatch(clearError());

    const url = getReportUrl(reportType);
    const payload = payloads[reportType]();

    try {
      const {data} = await axios.post(url, payload, {timeout: TIMEOUTS.EXTRA_LONG, _hideErrors: true});
      trackReport(reportType, payload, ReduxStore.getState().reportSections, data.url);
      ReduxStore.dispatch(resetReportUrl(data.url));
    } catch (e) {
      const response = getIn(e, ['response']) || {};
      ReduxStore.dispatch(error({status: response.status, message: response.statusText}));
    }
  },
};

export default ReportApi;
